<template>
  <div class="header1 flex-row-center">
    <div class="logo flex-row-center" @click="goTo('/home')">
      <a href="/">
        <img class="header_logo" src="@/assets/logo/logo.png" alt="logo" />
      </a>
    </div>
    <div class="tab-box">
      <div class="tab">
        <div
          class="flex-row-center"
          :class="item.path == $route.path ? 'active' : ''"
          v-for="(item, index) in routerList"
          :key="index"
          @click="goTo(item)"
        >
          {{ item.meta.title }}
        </div>
      </div>
      <!-- 是否登录 -->
      <div class="login flex-row-center" v-if="!userInfo.username">
        <span style="cursor: pointer" @click="goTo('/login')">登录</span>
        <span style="margin: 0 6px">/</span>
        <span style="cursor: pointer" @click="goTo('/register')">注册</span>
      </div>
      <div class="user-info" v-else>
        <!-- <span style="cursor: pointer" @click="goTo('/login')">{{
          username
        }}</span>
        <span style="margin: 0 6px">/</span>
        <span style="cursor: pointer" @click.native="logout">退出</span> -->
        <el-dropdown :hide-on-click="false">
          <span class="el-dropdown-link">
            <el-avatar>
              {{ userInfo? userInfo.username : "" }}</el-avatar
            ><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>修改资料</el-dropdown-item> -->
            <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routerList: [
        {
          path: "/",
          name: "home",
          component: {
            _custom: {
              type: "component-definition",
              display: "Index",
              tooltip: "Component definition",
              file: "src/views/home/index.vue"
            }
          },
          meta: { title: "首页" }
        },
        {
          path: "/news",
          component: {
            _custom: {
              type: "component-definition",
              display: "Index",
              tooltip: "Component definition",
              file: "src/views/news/index.vue"
            }
          },
          meta: { title: "新闻动态" }
        },
        {
          path: "/instructions",
          component: {
            _custom: {
              type: "component-definition",
              display: "Index",
              tooltip: "Component definition",
              file: "src/views/instructions/index.vue"
            }
          },
          meta: { title: "使用说明" }
        },
        {
          path: "/console",
          component: {
            _custom: {
              type: "component-definition",
              display: "Index",
              tooltip: "Component definition",
              file: "src/views/console/index.vue"
            }
          },
          meta: { title: "控制台" }
        },
        {
          path: "/developers",
          component: {
            _custom: {
              type: "component-definition",
              display: "Index",
              tooltip: "Component definition",
              file: "src/views/developers/index.vue"
            }
          },
          meta: { title: "企业开发者" }
        }
      ]
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  mounted() {
    // let arr = this.$router.options.routes[0].children;
    // this.routerList = arr.splice(0, arr.length - 3);
    if (window.localStorage.getItem("user")) {
      // console.log("看看",window.localStorage.getItem("user") )
      this.$store.commit(
        "SET_USER_INFO",
        JSON.parse(window.localStorage.getItem("user"))
      );
    }
  },
  methods: {
    goTo(item) {
      item.path ? this.$router.push(item.path) : this.$router.push(item);
    },
    async logout() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$store.dispatch("logout", "").then(() => {
            this.$router.push("/login");
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.active {
  color: rgba(58, 98, 215, 100);
}
.logo {
  height: 100%;
  cursor: pointer;
}
.tab-box {
  height: 100%;
  display: flex;
  color: #000;
}
.header1 {
  width: 100%;
  height: 68px;
  padding-left: 30px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: #fff;
  /* padding-left: 60px; */
  border-bottom: 1px solid #eee;
  justify-content: space-between;
}
.tab {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-right: 100px;
}
.tab div {
  height: 100%;

  margin-right: 20px;
  cursor: pointer;
}
.login {
  background: rgba(58, 98, 215, 100);
  height: 100%;
  width: 180px;
  color: #fff;
}
.user-info {
  width: 80px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
